import React from "react";
import PickupTickets from "./PickupTickets";
import "../css/OrderTicketsModal.css";

export default function OrderTicketsModal({ order, onClose }) {
	return (
		<div className="order-tickets-modal">
			<div className="otm-content">
				<div className="otm-close-bar">
					<button className="otm-close" onClick={onClose}>
						&times;
					</button>
				</div>
				<PickupTickets orderId={order.id} />
			</div>
		</div>
	);
}
